 
import { atomWithReset } from "jotai/utils";

export const PVIncentivesAtom = atomWithReset([]);
